import { useEffect } from "react"

import { Card, Form, Layout, Spin } from "antd"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"

import QuestionsForm from "../Components/Forms/QuestionsForm"
import LoginHeader from "../Components/LoginHeader"
import LogOutText from "../Components/LogOutText"
import PrivacyPolicy from "../Components/PrivacyPolicy"
import { authErrorReset } from "./LoginPage/redux/auth.actions"
import { getUserInfo, sendOnboardingForm } from "./User/redux/user.thunks"

function OnboardingQuestionsPage(props) {
  const {
    auth: { error, fetching, userInfo },
    saveFetching
  } = props

  const { t } = useTranslation()
  const [form] = Form.useForm()

  function handleSubmit(data) {
    props.sendOnboardingForm({ other_details: null, ...data })
  }

  useEffect(() => {
    document.title = "Onboarding - Chargeback"
    props.getUserInfo()
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  useEffect(() => {
    if (error) props.resetError()
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [error])

  return (
    <Layout>
      <Spin size="large" spinning={fetching || saveFetching}>
        <div className="login-row">
          <LoginHeader />
          <div className="login-content">
            <div className="content-main sign-up">
              <Card className="login-card">
                <h2 className="card-title">{t("How did you hear about us?")}</h2>
                <h4 className="card-subtitle-signup">
                  {t("Kindly select one of the options below.")}
                </h4>
                <QuestionsForm form={form} onSubmit={handleSubmit} />
              </Card>
              <PrivacyPolicy />
              {!userInfo?.new_onboarding_finished && <LogOutText />}
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  saveFetching: state.user.saveFetching
})

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  getUserInfo: () => dispatch(getUserInfo()),
  sendOnboardingForm: (data) => dispatch(sendOnboardingForm(data)),
  resetError: () => dispatch(authErrorReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingQuestionsPage)
